export default function isLowerEnvironment(): boolean {
  const apiUrl = import.meta.env.VITE_BFF_API_URL;
  if (!apiUrl) return false;

  const isInDevEnv =
    apiUrl?.includes('.qa.') ||
    apiUrl?.includes('.staging.') ||
    apiUrl?.endsWith('.test');
  return isInDevEnv;
}
